import { Spinner } from './Spinner';
import { centerPadded } from '@/styles/layout.css';
import { useDelayedFlag } from '@/hooks/useDelayedFlag';

/**
 * Standard in-shell loading placeholder: a horizontally-centred spinner with
 * comfortable top padding (the same `centerPadded` rhythm every settings/page
 * loader already uses). Replaces bare `<Spinner>` returns that rendered top-left.
 *
 * Self-delays: it only appears after ~250ms so fast loads don't flash a spinner.
 * Pass `loading` (whether the page is still fetching). For content with a known
 * card/list structure, prefer a skeleton (see ui/Skeleton) instead.
 */
export function PageLoader({ loading = true, delayMs = 250 }: { loading?: boolean; delayMs?: number }) {
  const show = useDelayedFlag(loading, delayMs);
  if (!show) return null;
  return (
    <div className={centerPadded} aria-busy="true" aria-live="polite">
      <Spinner size="md" />
    </div>
  );
}
